import { isNull } from 'lodash';
import { useViewMode } from 'store';

import useAddress from './use-address';

export const useReadOnlyWarning = () => {
  const { isReadOnly, isDeactivatedSafe } = useViewMode();

  const walletAccount = useAddress();

  const isNotAuthorized = !walletAccount && !isNull(walletAccount);

  if (isNotAuthorized) {
    return 'Your wallet is not connected';
  }

  if (isReadOnly) {
    return 'You are not a signer of this vault';
  }

  if (isDeactivatedSafe) {
    return 'Activate Asigna Pro to gain access to this sub-account';
  }

  return null;
};
